import type { IconData } from '@stacksjs/iconify-core'

export const tag: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M485.887 263.261L248 25.373A31.8 31.8 0 0 0 225.373 16H64a48.055 48.055 0 0 0-48 48v161.078A32.12 32.12 0 0 0 26.091 248.4l253.061 237.725a23.82 23.82 0 0 0 16.41 6.51q.447 0 .9-.017a23.83 23.83 0 0 0 16.79-7.734l173.329-188.405a23.94 23.94 0 0 0-.694-33.218M295.171 457.269L48 225.078V64a16.02 16.02 0 0 1 16-16h161.373l232.461 232.462Z\"/><path fill=\"currentColor\" d=\"M148 96a52 52 0 1 0 52 52a52.06 52.06 0 0 0-52-52m0 72a20 20 0 1 1 20-20a20.023 20.023 0 0 1-20 20\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default tag
